import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import Login from "@/pages/Login";
import Contracts from "@/pages/Contracts";
import EmailLogin from "@/pages/EmailLogin";
import ResetPassword from "@/pages/ResetPassword";
import Layout from "@/components/Layout";
import Dashboard from "@/pages/Dashboard";
import Clients from "@/pages/Clients";
import ClientDetail from "@/pages/ClientDetail";
import Properties from "@/pages/Properties";
import Tenants from "@/pages/Tenants";
import TenantDetail from "@/pages/TenantDetail";
import Outstanding from "@/pages/Outstanding";
import Inbox from "@/pages/Inbox";
import BulkDunning from "@/pages/BulkDunning";
import BrievenGenerator from "@/pages/BrievenGenerator";
import Payouts from "@/pages/Payouts";
import Reports from "@/pages/Reports";
import Tasks from "@/pages/Tasks";
import Settings from "@/pages/Settings";
import ImportData from "@/pages/ImportData";
import ArchivePage from "@/pages/Archive";
import SignAgreement from "@/pages/SignAgreement";
import PortalLogin from "@/pages/PortalLogin";
import PortalVerify from "@/pages/PortalVerify";
import PortalDashboard from "@/pages/PortalDashboard";
import PortalPaid from "@/pages/PortalPaid";
import Complaints from "@/pages/Complaints";
import PortalComplaint from "@/pages/PortalComplaint";

const Loader = () => (
  <div className="min-h-screen flex items-center justify-center bg-slate-50">
    <div className="h-10 w-10 rounded-full border-4 border-blue-900 border-t-transparent animate-spin" />
  </div>
);

const Protected = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) return <Loader />;
  if (!user) return <Navigate to="/" replace />;
  return children;
};

const AdminOnly = ({ children }) => {
  const { user } = useAuth();
  if (user && user.role !== "admin") return <Navigate to="/app" replace />;
  return children;
};

function AppRouter() {
  return (
    <Routes>
      <Route path="/" element={<Login />} />
      <Route path="/inloggen" element={<EmailLogin />} />
      <Route path="/wachtwoord-herstellen" element={<ResetPassword />} />
      <Route path="/teken/:token" element={<SignAgreement />} />
      <Route path="/portaal" element={<PortalLogin />} />
      <Route path="/portaal/verifieer" element={<PortalVerify />} />
      <Route path="/portaal/overzicht" element={<PortalDashboard />} />
      <Route path="/portaal/betaald" element={<PortalPaid />} />
      <Route path="/klacht/:code" element={<PortalComplaint />} />
      <Route path="/app" element={<Protected><Layout /></Protected>}>
        <Route index element={<Dashboard />} />
        <Route path="opdrachtgevers" element={<Clients />} />
        <Route path="opdrachtgevers/:id" element={<ClientDetail />} />
        <Route path="panden" element={<Properties />} />
        <Route path="huurders" element={<Tenants />} />
        <Route path="huurders/:id" element={<TenantDetail />} />
        <Route path="contracten" element={<Contracts />} />
        <Route path="postvak" element={<Inbox />} />
        <Route path="openstaand" element={<Outstanding />} />
        <Route path="bulk-aanmaningen" element={<BulkDunning />} />
        <Route path="brievengenerator" element={<BrievenGenerator />} />
        <Route path="klachten" element={<Complaints />} />
        <Route path="uitbetalingen" element={<Payouts />} />
        <Route path="rapportages" element={<AdminOnly><Reports /></AdminOnly>} />
        <Route path="taken" element={<Tasks />} />
        <Route path="importeren" element={<AdminOnly><ImportData /></AdminOnly>} />
        <Route path="archief" element={<ArchivePage />} />
        <Route path="instellingen" element={<AdminOnly><Settings /></AdminOnly>} />
      </Route>
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <AppRouter />
          <Toaster position="top-right" richColors />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
